/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Terms_Section3_Li3Inputs */

const en_terms_section3_li3 = /** @type {(inputs: Terms_Section3_Li3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Remove or alter any copyright or attribution notices`)
};

const ko_terms_section3_li3 = /** @type {(inputs: Terms_Section3_Li3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`저작권 또는 저작자 표시를 제거하거나 변경하는 행위`)
};

const ja_terms_section3_li3 = /** @type {(inputs: Terms_Section3_Li3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`著作権表示や帰属表示を削除または変更すること`)
};

/**
* | output |
* | --- |
* | "Remove or alter any copyright or attribution notices" |
*
* @param {Terms_Section3_Li3Inputs} inputs
* @param {{ locale?: "en" | "ko" | "ja" }} options
* @returns {LocalizedString}
*/
export const terms_section3_li3 = /** @type {((inputs?: Terms_Section3_Li3Inputs, options?: { locale?: "en" | "ko" | "ja" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Terms_Section3_Li3Inputs, { locale?: "en" | "ko" | "ja" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_terms_section3_li3(inputs)
	if (locale === "ko") return ko_terms_section3_li3(inputs)
	return ja_terms_section3_li3(inputs)
});